import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import YoutubePlay from '@elem/SVGIcon/OutdoorRecreation/YoutubePlay';
import { Scrollbar } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function B() {
    const { useLang, useState, useEffect, useRouter } = useGlobal();
    const { t } = useLang('powerindependence');
    const { locale } = useRouter();
    const [source, setSource] = useState('');
    const [gap, setGap] = useState(24);
    let cards: any = [
        {
            img: '/responsive/picture/power-independence/5_1',
            text: t('secB_list1'),
            link: {
                de: 'https://blog.ecoflow.com/uk/secure-energy-independence-with-ecoflow-powerocean-munich-family-redefines-home-energy-with-the-power-of-the-sun/',
                eu: 'https://blog.ecoflow.com/uk/secure-energy-independence-with-ecoflow-powerocean-munich-family-redefines-home-energy-with-the-power-of-the-sun/',
                uk: 'https://blog.ecoflow.com/uk/secure-energy-independence-with-ecoflow-powerocean-munich-family-redefines-home-energy-with-the-power-of-the-sun/',
                it: '',
                es: '',
            },
        },
        {
            img: '/responsive/picture/power-independence/5_2',
            text: t('secB_list2'),
            video: {
                de: 'https://www.youtube.com/embed/IVY0drpss5g?si=0i53NZ5VZ9GvC0wq',
                eu: 'https://www.youtube.com/embed/IVY0drpss5g?si=trHdkx5aAzm2c-3R',
                uk: '',
                it: '',
                es: '',
            },
        },
    ];

    if (locale === 'uk') {
        cards = cards.slice(0, 1);
    }

    const handleClick = (card: any) => {
        if (card?.video) {
            setSource(card?.video[locale]);
        } else {
            window.open(card?.link[locale], '_blank');
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
            window.addEventListener('resize', resetGap);
            return () => window.removeEventListener('resize', resetGap);
        }
    }, []);

    return (
        <div className={`power-independence-B ${css['power-independence-B']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secB_title')}</p>
                </div>
                <Swiper
                    className="swiper-box"
                    effect="fade"
                    modules={[Scrollbar]}
                    spaceBetween={gap}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 32,
                        snapOnRelease: true,
                    }}
                >
                    {cards?.map((card: any, k: number) => (
                        <SwiperSlide className={`swiper-item item-${k + 1}`} key={k} onClick={() => handleClick(card)}>
                            <EFPicture src={`${card?.img}.jpg`} srcPad={`${card?.img}_375.jpg`} srcMobile={`${card?.img}_375.jpg`} alt={card?.text} />
                            {card?.video && <YoutubePlay className="youtube-icon" />}
                            <p className="card-text">
                                {card?.text}
                                {card?.link?.[locale] && (
                                    <svg className="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M7.5 15L12.5 10L7.5 5" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                )}
                            </p>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            {Object.keys(source)?.length > 0 && (
                <EFVideoModal visible={Boolean(source)} source={source} onClose={() => setSource('')} playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'} />
            )}
        </div>
    );
}
